import React from "react";

export const PriceColumnFormatter = (cellContent, row) => {
  const formattedPrice = row.price ? row.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0";
  return <>{formattedPrice}</>;
};
